import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, path, type = 'website' }) => {
    const siteName = 'Wayside Maple';
    const baseTitle = 'Wayside Maple — Premium Small-Batch Maple Syrup';
    const fullTitle = title
        ? (title.startsWith('Wayside Maple') ? title : `${title} | ${siteName}`)
        : baseTitle;
    const ogImage = 'https://www.waysidemaplefarm.com/images/wayside-logo-horizontal.png';

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:image" content={ogImage} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            {path && <link rel="canonical" href={`https://waysidemaplefarm.com${path}`} />}
        </Helmet>
    );
};

export default SEO;
